var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrderReturn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.46875,
    y: 0.412842,
    width: 37.8012,
    height: 37.8012,
    rx: 18.9006,
    fill: "#636363"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4156_11802)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.1641 27.8601V28.4248C13.1641 28.9437 13.5863 29.366 14.1052 29.366H24.9999C25.5189 29.366 25.9411 28.9437 25.9411 28.4248V27.8601H13.1641Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.084 18.0491V17.4821C27.084 16.9787 26.8314 16.5153 26.4085 16.2424L25.9169 15.9253V15.0283H26.1052C26.417 15.0283 26.6699 14.7755 26.6699 14.4636C26.6699 14.1518 26.417 13.8989 26.1052 13.8989H12.9646C12.6527 13.8989 12.3999 14.1518 12.3999 14.4636C12.3999 14.7755 12.6527 15.0283 12.9646 15.0283H13.1528V15.9308L12.6804 16.2457C12.269 16.52 12.0234 16.9789 12.0234 17.4732V19.7916C12.0234 20.0495 12.1982 20.2746 12.448 20.3386L15.8917 21.2204L12.448 22.1022C12.1982 22.1662 12.0234 22.3914 12.0234 22.6493V25.3754C12.0234 26.0501 12.519 26.6111 13.1652 26.7139H25.9422C26.5884 26.6111 27.084 26.0501 27.084 25.3754V24.4069C27.084 24.1369 26.8928 23.9046 26.6277 23.8527L24.556 23.4473L26.6277 23.0418C26.8928 22.99 27.084 22.7577 27.084 22.4876V20.5633C27.084 20.3221 26.9308 20.1076 26.7027 20.0292L24.5968 19.3062L26.7027 18.5831C26.9308 18.5049 27.084 18.2903 27.084 18.0491Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4607 12.7694L21.5942 11.5526C21.635 11.1809 21.5152 10.808 21.2656 10.5295C21.016 10.251 20.6584 10.0913 20.2844 10.0913H18.8137C18.4397 10.0913 18.0821 10.251 17.8325 10.5295C17.5829 10.808 17.4631 11.1809 17.5039 11.5526L17.6374 12.7694L21.4607 12.7694Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4156_11802"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.2748,
    height: 19.2748,
    fill: "white",
    transform: "translate(9.91406 10.0913)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderReturn);
export default __webpack_public_path__ + "static/media/orderReturn.75a9a0eacbeadf8e185d0262ecc03aec.svg";
export { ForwardRef as ReactComponent };